import { UtmCampaignEnum } from '../UtmCampaignEnum'

/**
 * for email links
 */
export const appendUtmQueryParamsToALink = (
  url: string,
  utmCampaign?: UtmCampaignEnum
) => {
  if (!url.includes('?')) {
    url += '?'
  } else {
    url += '&'
  }
  if (utmCampaign) {
    url += `utm_source=LooopApp&utm_campaign=${utmCampaign}&utm_medium=email`
  } else {
    url += `utm_source=LooopApp&utm_medium=email`
  }
  return url
}
